import * as yup from 'yup';

export const getSchema = () => {
  const staticValidations = {
    ru: yup.object().required(),
    en: yup.object().required(),
  };

  return yup.object().shape(staticValidations);
};
